const ECOM_APP_DEF_ID = '1380b703-ce81-ff05-f115-39571d94dfcd';
export const navigateToCheckout = ({ wixCodeApi })=>async (checkoutId)=>{
        const ecomPublicApi = await wixCodeApi.site.getPublicAPI(ECOM_APP_DEF_ID);
        await ecomPublicApi.navigate.toCheckout({
            checkoutId,
            disableContinueShopping: true
        });
    };

//# sourceMappingURL=navigate-to-checkout.js.map